import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import publicService from "../services/PublicService";

export const fetchCourses = createAsyncThunk(
  'courses/fetchCourses',
  async (_, { getState, rejectWithValue }) => {
    const { coursesListPublic } = getState();

    if (coursesListPublic.items?.length > 0) {
      return rejectWithValue('Already have data');
    }
    
    try {
      const response = await publicService.courses.getCourses();
      return response.content; // This will be the actual course data from NrksEducationResponse
    } catch (error) {
      return rejectWithValue(error.message || error.response?.data?.message || 'Something went wrong');
    }
  }
);

export const fetchCourseById = createAsyncThunk(
  "course/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await publicService.courses.getCourse(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);



const coursesSlice = createSlice({
  name: 'CoursesListPublic',
  initialState: {
    items: [],
    course: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCoursesError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCourses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCourses.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload; // Fixed: use items instead of courses
      })
      .addCase(fetchCourses.rejected, (state, action) => {
        state.loading = false;
        if (action.payload !== 'Already have data') {
          state.error = action.payload;
        }
      })
       .addCase(fetchCourseById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCourseById.fulfilled, (state, action) => {
        state.loading = false;
        state.course = action.payload;
      })
      .addCase(fetchCourseById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.course = null;
      });;
  },
});

export const { clearCoursesError } = coursesSlice.actions;
export default coursesSlice.reducer;
